<div class="custom-mat-dialog">
    <div mat-dialog-title class="mat-dialog-header-with-close-btn">
        <!-- <h4 class="xl:text-2xl lg:text-xl text-lg text-black font-medium"> {{ data?.selectedQuestion?.description ||
            'Checklist Images'}}</h4> -->
        <button mat-icon-button aria-label="Close" class="close-icon" (click)="back()">
            <mat-icon svgIcon="c:x"></mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <div class="h-full pb-5">
            <div class="h-full">
                @if (imageData) {
                    <pintura-editor [src]="imageData" [options]="editorOptions"
                        [markupEditorToolStyles]="markupEditorToolStyles" (selectcontrol)="selectControl($event)" 
                        [imageReader]="editorOptions.imageReader"
                        (load)="handleInlineLoad($event)" (process)="handleInlineProcess($event)"
                        (selectstyle)="handleEditorSelectStyle($event)" (close)="handleCloseEvent()">
                    </pintura-editor>
                }
            </div>
        </div>
    </mat-dialog-content>
</div>